import { useLocalStorage } from '@/hooks'

import { parseLinkColor } from './linked-columns.constants'

export const SAVED_LINK_COLORS_STORAGE_KEY = 'linked-columns-saved-link-colors'

export const MAX_SAVED_LINK_COLORS = 3

// Note: a stable empty list - useLocalStorage re-subscribes to storage events when its initial value changes
const NO_SAVED_COLORS: string[] = []

// Note: the custom colors the user picked last, newest first; one list for every page that uses LinkedColumns
export const useSavedLinkColors = (): [string[], (color: string) => void] => {
  const [stored, setStored] = useLocalStorage<string[]>(
    SAVED_LINK_COLORS_STORAGE_KEY,
    NO_SAVED_COLORS,
  )

  const colors = (Array.isArray(stored) ? stored : [])
    .map(parseLinkColor)
    .filter(Boolean)
    .slice(0, MAX_SAVED_LINK_COLORS)

  const save = (color: string) =>
    setStored([color, ...colors.filter((item) => item !== color)].slice(0, MAX_SAVED_LINK_COLORS))

  return [colors, save]
}
